import baseUrl from '../utils/baseUrl'
import axios from './api'

const getVehiclesByClientId = async (id) =>
    await axios.get(baseUrl + `/vehicles/user-id/${id}`).then((response) => response.data)

export { getVehiclesByClientId }
